<template>
  <md-card>
    <md-card-header class="md-card-header-green md-card-header-icon">
      <div class="card-icon">
        <md-icon>link</md-icon>
      </div>
      <h4 class="title">
        Linki do serwisów zewnętrznych
      </h4>
    </md-card-header>

    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-small-size-100 md-size-75">
          <md-field>
            <label>Nazwa</label>
            <md-input v-model="linkName" type="text" />
          </md-field>
        </div>
        <div class="md-layout-item md-small-size-100 md-size-25">
          <md-button class="md-raised md-info" @click="addLink"
            >Dodaj nowy</md-button
          >
        </div>
      </div>
      <div class="md-layout">
        <div class="md-layout-item md-size-100 md-size-75">
          <md-table v-model="links" table-header-color="green">
            <ExternalLinkItem
              slot="md-table-row"
              slot-scope="{ item }"
              :link="item"
            />
          </md-table>
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import ExternalLinkItem from '@/views/crm-views/UserProfile/ExternalLinkItem'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ExternalLinksForm',
  components: {
    ExternalLinkItem,
  },
  data: () => ({
    linkName: '',
  }),
  created() {
    this.fetchLinksList()
  },
  computed: {
    ...mapState({
      links: state => state.externalLinks.userExternalLinks,
    }),
  },
  methods: {
    ...mapActions(['fetchLinksList', 'addExternalLink']),
    async addLink() {
      await this.addExternalLink(this.linkName)
      this.linkName = ''
    },
  },
}
</script>

<style scoped></style>
